
import ReactApexChart from "react-apexcharts";
import { useTheme } from "@mui/material/styles";
import { useSubscriptionGrowth } from "../../hooks/useSubscriptions";
import { CircularProgress, Box } from "@mui/material";

const ApexChart2 = ({ period = '12m' }) => {
    const theme = useTheme();
    const { data: growthData, isLoading, error } = useSubscriptionGrowth(period);

    const barColor = "#00dec3"; // Accent color
    const labelColor = theme.palette.text.primary; // Axis & legend labels
    // const bgColor = theme.palette.background.paper; // Chart background
    const isDarkMode = theme.palette.mode === "dark";

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height={350}>
                <CircularProgress />
            </Box>
        );
    }

    if (error || !growthData?.data) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height={350}>
                <div style={{ color: labelColor }}>Failed to load growth data</div>
            </Box>
        );
    }

    const { currentYear, previousYear, labels } = growthData.data;

    const series = [
        {
            name: "Last Year",
            data: previousYear,
        },
        {
            name: "This Year",
            data: currentYear,
        },
    ];

    const options = {
        chart: {
            height: 350,
            type: "area",
            background: "transparent", // Make the chart background transparent
            zoom: { enabled: false },
            toolbar: { show: false },
        },
        theme: {
            mode: isDarkMode ? "dark" : "light",
        },
        dataLabels: { enabled: false },
        stroke: { curve: "smooth" },
        colors: [barColor, "#8884d8"], // Customize chart lines if needed
        xaxis: {
            categories: labels || [
                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
            ],
            labels: {
                style: {
                    colors: labelColor,
                },
            },
        },
        yaxis: {
            labels: {
                style: {
                    colors: labelColor,
                },
            },
        },
        tooltip: {
            theme: isDarkMode ? "dark" : "light",
        },
        legend: {
            labels: {
                colors: labelColor,
            },
        },
        grid: {
            borderColor: isDarkMode ? "#444" : "#e7e7e7",
        },
    };

    return (
        <div>
            <ReactApexChart
                options={options}
                series={series}
                type="area"
                height="100%"
            />
        </div>
    );
};

export default ApexChart2;
